module.exports = __webpack_public_path__ + "static/turquia-003.thumb-4e4e8c4b7d08c278208c68fbf53665f8.jpg";